import { useQuery } from '@tanstack/react-query'
import { fetchMenu } from '../api/menu'

const FALLBACK = [
  { id: 1, label: 'Home',     path: '/',         children: [] },
  { id: 2, label: 'Packages', path: '/packages', children: [] },
  { id: 3, label: 'Services', path: '/services', children: [] },
  { id: 4, label: 'Gallery',  path: '/gallery',  children: [] },
  { id: 5, label: 'About',    path: '/about',    children: [] },
]

function buildTree(flat) {
  const map = {}
  flat.forEach(item => { map[item.id] = { ...item, children: [] } })
  const roots = []
  flat.forEach(item => {
    if (item.parent && map[item.parent]) {
      map[item.parent].children.push(map[item.id])
    } else {
      roots.push(map[item.id])
    }
  })
  return roots
}

export function useMenu() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['menu'],
    queryFn: fetchMenu,
    staleTime: 5 * 60 * 1000,
  })

  const raw = (!isLoading && !isError && data?.length) ? data : FALLBACK
  return { items: buildTree(raw), isLoading }
}
